import { BLOG_ARTICLES } from "@config/blog-config";
import martin from "@public/static/story/martin-vik.png";
import { BlogHeroSection } from "@shared/components/blog/blog-hero-section";
import { IntroSection } from "@shared/components/blog/intro-section";
import { MainSection } from "@shared/components/blog/main-section";
import { Sidebar } from "@shared/components/blog/sidebar";
import { useLocale } from "@translations/locale-context";
import { StaticImage } from "@ui/components/image/static-image";
import { useTranslation } from "next-i18next";
import React, { FC, memo } from "react";

const ContentCs: FC = () => (
    <>
        <h2 className="ui-typo-h5 mb-10">Kdo jsi?</h2>
        <p className="mb-6">
            Jsem Vikus. Narodil jsem se&nbsp;ve Vrchlabí, ale většinu dosavadního života jsem prožil v&nbsp;Jilemnici.
            Později, když jsem odešel od&nbsp;rodičů, má cesta vedla zpět do&nbsp;Vrchlabí, následně do&nbsp;Horní
            Branné a&nbsp;do&nbsp;Jičína. Nicméně, z&nbsp;půlky jsem teď taky vlastně tak trochu Liberečák.
        </p>
        <p className="mb-6">
            Volný čas, který netrávím u&nbsp;počítače, zpravidla trávím v&nbsp;lese jakožto orienťák. Dnes už víc jako
            organizátor, ale stále i&nbsp;jako závodník. Jo a&nbsp;taky po&nbsp;odpoledních tisknu pro orienťák mapy.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Co bylo před UX Fans?</h2>
        <p className="mb-6">
            Kolem počítačů se&nbsp;motám již od&nbsp;doby, kdy jsem dokázal vzteky třísknout myší o&nbsp;stůl, takže asi
            od 3&nbsp;let. Zhruba od 11&nbsp;let se&nbsp;šťourám ve&nbsp;tvorbě webů. Postupně od&nbsp;úplně amatérské,
            až po&nbsp;profesionální úroveň. Vždycky jsem se&nbsp;však cítil více jako webdesignér, než programátor.
        </p>
        <p className="mb-6">
            Osmileté gymnázium mě tou cestou ještě více usměrnilo, a&nbsp;tak jsem se&nbsp;vydal studovat polygrafii.
            Zároveň jsem, tak trochu dobrovolně-povinně, přebral rodinný podnik na&nbsp;zakázkovou výrobu reklam. Co víc
            si přát – studovat a&nbsp;k tomu podnikat s&nbsp;vlastním otcem. :-) Během tohoto silně punkového období
            jsem získal první komerční zakázky na&nbsp;vývoj webů. Nejprve jako web designér, ale ve&nbsp;skutečnosti
            víc vlastně jako kodér (frontenďák, chcete-li). Později jsem si dal roční zkušenost jako kodér (frontend,
            fullstack, whatever, …) ve&nbsp;vrchlabské digitální agentuře. A&nbsp;tam jsem se&nbsp;přece jen definitivně
            zaměřil právě na&nbsp;vývoj webů.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Co tě do UX Fans přivedlo?</h2>
        <p className="mb-6">
            Vlastně za&nbsp;to může první seznámení s&nbsp;React.js. Chtěl jsem v&nbsp;té technologii pracovat
            a&nbsp;ve&nbsp;Vrchlabí to v&nbsp;roce 2017 nešlo. Taky jsem rád, že teď pracuji v&nbsp;týmu lidí, který
            jede na&nbsp;stejné vlně, jak já. Nicméně k&nbsp;UXF mě přivedla tak trochu náhoda. Znal jsem
            se&nbsp;s&nbsp;někým, kdo se&nbsp;znal s&nbsp;někým (znáte to)... a&nbsp;tak se&nbsp;ke mně dostal inzerát.
            UXF hledalo, tehdy ještě pod jiným názvem, někoho do&nbsp;role „Responsive maestro“.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Jaká je tvoje role v UX Fans?</h2>
        <p className="mb-6">
            Oslím můstkem se&nbsp;dostáváme do&nbsp;mé současné role v&nbsp;UXF. Jako frontend vývojář mám
            na&nbsp;starosti kódovat – vytvářet uživatelské rozhraní. Dalo by se&nbsp;také říct, že vdechuji život
            vizuálním prvkům webové stránky nebo aplikace.
        </p>
        <p className="mb-6">
            S&nbsp;rostoucím týmem také brífuji nové frontenďáky. A&nbsp;protože už v&nbsp;téhle oblasti působím celkem
            dost dlouho (since HTML 4.01, CSS 1 a&nbsp;PHP 4 a&nbsp;jiné dinosaurismy), mám tu drzost považovat
            se&nbsp;již za&nbsp;seniorního frontend vývojáře. Baví mě rýpat se&nbsp;ve složitějším UI s&nbsp;tlakem
            na&nbsp;dobré UX a&nbsp;accessibility.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Baví tě být součástí UX Fans?</h2>
        <p>
            Tak to se&nbsp;ví. Jsem na&nbsp;palubě téměř od&nbsp;úplných začátků. Mám rád náš firemní punk rock,
            a&nbsp;plně se&nbsp;ztotožňuji s&nbsp;filozofií firmy. I&nbsp;přes, někdy až otravné sedmdesátikilometrové,
            cesty na&nbsp;Liďáky se&nbsp;po pěti letech stále těším do&nbsp;práce.
        </p>
    </>
);

const ContentEn: FC = () => (
    <>
        <h2 className="ui-typo-h5 mb-10">Who are you?</h2>
        <p className="mb-6">
            I&apos;m Vikus. I was born in Vrchlabí, but I have lived most of my life in Jilemnice. Later, when
            I&nbsp;left&nbsp;my parents, my path led back to&nbsp;Vrchlabí, then to&nbsp;Horní Branná and&nbsp;Jičín.
            However, half of me is actually a bit of a Liberec guy now.
        </p>
        <p className="mb-6">
            When I don&apos;t spend my free time at the computer, I usually spend it in the woods as an&nbsp;orienteer.
            Nowadays more as an organizer, but still as a competitor. Oh, and&nbsp;I also print maps for orienteering in
            the afternoons.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What was before UX Fans?</h2>
        <p className="mb-6">
            I&apos;ve been around computers since I could slam my mouse on a desk in anger, so since I&nbsp;was about 3
            years old. I&apos;ve been dabbling in web development since I&nbsp;was about 11&nbsp;years old. Gradually
            from&nbsp;completely amateur to&nbsp;professional level. However, I have always felt more like a web
            designer than a programmer.
        </p>
        <p className="mb-6">
            Eight years of high school set me even further down that path, and I went on to study polygraphy. At the
            same time, somewhat voluntarily, I took over the family business for&nbsp;custom ad production. What more
            could you ask for - to study and&nbsp;to do business with&nbsp;my own father. :-) During this heavily punk
            period, I won my first commercial web development contracts. First as a web designer, but in&nbsp;reality
            more actually as a coder (a front end coder if you will). Later on I got a year experience as a
            coder&nbsp;(frontend, fullstack, whatever, ...) in&nbsp;a digital agency in Vrchlabí. And&nbsp;there&nbsp;I
            finally focused on&nbsp;web development.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What brought you to UX Fans?</h2>
        <p className="mb-6">
            Actually, it was the first introduction to React.js. I&nbsp;wanted to work in this technology and
            I&nbsp;couldn&apos;t do it in Vrchlabí in 2017. I&apos;m also happy that I&apos;m now working in&nbsp;a team
            of people who are riding&nbsp;the same wave as me. However, it was a bit of a coincidence that brought me
            to&nbsp;UXF. I knew&nbsp;someone who&nbsp;knew&nbsp;someone who&nbsp;knew&nbsp;someone who (you know)... and
            that&apos;s how the ad came to me. UXF was looking, then under a different name, for someone to fill
            the&nbsp;role of &quot;Responsive Maestro&quot;.
        </p>
        <p className="mb-6">
            This is the bridge to my current role in UXF. As a frontend developer, I&apos;m responsible for coding -
            creating the user interface. You could also say that I breathe life into the visual elements of a website or
            app.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What is your role in UX Fans?</h2>
        <p className="mb-6">
            I&nbsp;am also briefing new frontend developers with the growing team. And&nbsp;since I&apos;ve been in this
            field for quite a while (since HTML&nbsp;4.01, CSS&nbsp;1 and&nbsp;PHP 4 and&nbsp;other dinosaurs),
            I&nbsp;have the audacity to consider myself&nbsp;already a senior frontend developer. I&nbsp;enjoy
            tinkering&nbsp;with&nbsp;complex UI with&nbsp;pressure for&nbsp;good UX and&nbsp;accessibility.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Do you enjoy being part of UX Fans?</h2>
        <p>
            Absolutely. I&apos;ve been on board almost from the very beginning. I&nbsp;love our corporate punk rock, and
            I fully identify with the company&apos;s philosophy. Despite the, sometimes annoying, seventy-kilometer
            trips to&nbsp;Liďáky, I&nbsp;still look forward to&nbsp;going&nbsp;to&nbsp;work after five&nbsp;years.
        </p>
    </>
);

export const MartinVikStoryPage = memo(() => {
    const { t } = useTranslation();
    const locale = useLocale();

    const sidebar = (
        <Sidebar
            buttonUrl="https://www.linkedin.com/in/martinvik1992/"
            buttonText="LinkedIn"
            inCompanySince={t("story:martinVik.inCompanySince")}
            position={t("story:martinVik.position")}
            hashtags={BLOG_ARTICLES.find((a) => a.key === "martin-vik")?.hashtags}
        />
    );

    return (
        <main>
            <BlogHeroSection title={t("story:martinVik.title")} name="Martin Vik">
                <StaticImage
                    src={martin}
                    alt=""
                    widths={[400, 400, 583, 448, 540, 583]}
                    width={583}
                    imgClassName="!w-full object-contain"
                />
            </BlogHeroSection>
            <MainSection className="mb-12 md:mb-20">
                <IntroSection sidebar={sidebar}>
                    <div className="ui-typo-body">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
                </IntroSection>
                <div className="mt-12 flex flex-col justify-between border-t pt-12 xl:hidden">{sidebar}</div>
            </MainSection>
        </main>
    );
});

MartinVikStoryPage.displayName = "MartinVikStoryPage";
